module.exports = __webpack_public_path__ + "img/7314637.9b84a189.png";